import { createContext, useContext, type ReactNode } from 'react';
import type { RuntimeConfig } from './runtime';

const ConfigContext = createContext<RuntimeConfig | null>(null);

export function ConfigProvider({ value, children }: { value: RuntimeConfig; children: ReactNode }) {
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
}

export function useConfig(): RuntimeConfig {
  const ctx = useContext(ConfigContext);
  if (!ctx) throw new Error('useConfig() called outside ConfigProvider');
  return ctx;
}
